module.exports = __webpack_public_path__ + "static/img/14.0273858.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/14.png
// module id = +Fov
// module chunks = 0